<template>
  <div class="ma-4">
    <div class="text-h4 my-4">Auditoria</div>

    <v-form>
      <v-row dense>
        <v-col>
          <v-datetime-picker
            label="Data início"
            v-model="datetimestart"
            :date-picker-props="dateProps"
            :time-picker-props="timeProps"
            :text-field-props="textProps"
            date-format="dd/MM/yyyy"
            time-format="HH:mm"
          >
            <template slot="dateIcon">
              <v-icon>mdi-calendar-month</v-icon>
            </template>
            <template slot="timeIcon">
              <v-icon>mdi-clock-outline</v-icon>
            </template>
            <template slot="actions" slot-scope="{ parent }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    ripple
                    outlined
                    icon
                    color="darkRed"
                    @click="cancelEvent(parent)"
                    dark
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </template>
                <span>Cancelar</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    ripple
                    outlined
                    icon
                    color="bluePcm"
                    @click="parent.okHandler"
                    dark
                    v-bind="attrs"
                    v-on="on"
                    class="ml-2"
                  >
                    <v-icon>mdi-check</v-icon>
                  </v-btn>
                </template>
                <span>Confirmar</span>
              </v-tooltip>
            </template>
          </v-datetime-picker>
        </v-col>

        <v-col>
          <v-datetime-picker
            label="Data fim"
            v-model="datetimeend"
            :date-picker-props="dateProps"
            :time-picker-props="timeProps"
            :text-field-props="textProps"
            date-format="dd/MM/yyyy"
            time-format="HH:mm"
          >
            <template slot="dateIcon">
              <v-icon>mdi-calendar-month</v-icon>
            </template>

            <template slot="timeIcon">
              <v-icon>mdi-clock-outline</v-icon>
            </template>

            <template slot="actions" slot-scope="{ parent }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    ripple
                    outlined
                    icon
                    color="darkRed"
                    @click="cancelEvent(parent)"
                    dark
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </template>
                <span>Cancelar</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    ripple
                    outlined
                    icon
                    color="bluePcm"
                    @click="parent.okHandler"
                    dark
                    v-bind="attrs"
                    v-on="on"
                    class="ml-2"
                  >
                    <v-icon>mdi-check</v-icon>
                  </v-btn>
                </template>
                <span>Confirmar</span>
              </v-tooltip>
            </template>
          </v-datetime-picker>
        </v-col>

        <v-col>
          <v-select dense outlined v-model="form.usuarios" :items="usuarios" label="Usuários" multiple>
            <template v-slot:selection="{ item, index }">
              <span v-if="index === 0">{{ item.text }}</span>
              <v-chip v-if="index === 1" small>
                <span class="caption"> (+{{ form.usuarios.length - 1 }}) </span>
              </v-chip>
            </template>
            <template v-slot:prepend-item>
              <v-list-item ripple @click="toggleUsuarios">
                <v-list-item-action>
                  <v-icon :color="form.usuarios.length > 0 ? 'indigo darken-4' : ''">
                    {{ iconUsuarios }}
                  </v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>
                    Selecionar Todos
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider class="mt-2" />
            </template>
          </v-select>
        </v-col>
        <v-col cols="2" class="text-right">
          <v-btn dark color="bluePcm" @click="gerarAuditoria">Gerar</v-btn>
        </v-col>
      </v-row>
    </v-form>

    <v-divider class="mx-2" />

    <v-sheet v-show="showSkeleton" class="pa-3">
      <v-skeleton-loader class="mx-auto" type="table" />
    </v-sheet>

    <TableEventosAudit :eventosAuditoria="eventosAuditoria" v-if="showReportData && !showSkeleton" />
  </div>
</template>

<script>
import moment from 'moment'
import { mapActions, mapGetters } from 'vuex'

import { registerVuexModule } from '@/utils/vuexUtils'

import auditStore from '../_store'
import TableEventosAudit from '../_components/TableEventosAudit'

export default {
  components: { TableEventosAudit },
  data: () => ({
    form: {
      dataHoraInicio: '',
      dataHoraFim: '',
      usuarios: [],
    },
    usuarios: [],
    datetimestart: new Date(),
    datetimeend: new Date(),
    dateProps: {
      locale: 'pt-br',
      color: 'bluePcm',
    },
    timeProps: {
      color: 'bluePcm',
      scrollable: true,
      format: '24hr',
    },
    textProps: {
      dense: true,
      outlined: true,
    },
    namespaces: {
      AlliasRegex: 'Expressão Regular',
      Audio: 'Áudio',
      CentroDeCusto: 'Centro de Custo',
      Conferencia: 'Conferência',
      Config: 'Configuração',
      Facilidade: 'Facilidade',
      Grupo: 'Grupos',
      MusicaDeEspera: 'Música de Espera',
      Ramais: 'Ramais',
      Rota: 'Rota',
      Tags: 'Tags',
      Troncos: 'Troncos',
      Tarefas: 'Tarefas',
      Ura: 'Ura',
      Agente: 'Agente',
      Pause: 'Pausa',
      WebHook: 'Webhook',
      Queue: 'Fila',
      Pesquisa: 'Pesquisa',
      Role: 'Perfil',
      User: 'Usuário',
      Departamento:'Departamento',
      Tronco:'Tronco',
      ConfigCallCenter: 'Configuração Monitor',
      PjsipTransport: 'Transport',
    },
    eventos: {
      created: 'Criado',
      updated: 'Atualizado',
      deleted: 'Deletado',
    },
    eventosAuditoria: [],
    showReportData: false,
    showSkeleton: false,
    itemsPerPage: 20,
  }),

  computed: {
    ...mapGetters('auditoriaModuleAuditStore', ['getUsers', 'getDadosAuditoria']),

    todosUsuariosSelecionados() {
      return this.form.usuarios.length === this.usuarios.length
    },
    algunsUsuariosSelecionados() {
      return this.form.usuarios.length > 0 && !this.todosUsuariosSelecionados
    },
    iconUsuarios() {
      if (this.todosUsuariosSelecionados) return 'mdi-close-box'
      if (this.algunsUsuariosSelecionados) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },
  },

  async created() {
    this.datetimestart.setHours(0)
    this.datetimestart.setMinutes(0)
    this.datetimeend.setHours(23)
    this.datetimeend.setMinutes(59)

    registerVuexModule(this.$store, 'auditoriaModuleAuditStore', auditStore)
    await this.listarUsuarios()
    this.usuarios = this.getUsers.map(user => ({ text: user.name, value: user.id }))
  },

  methods: {
    ...mapActions('auditoriaModuleAuditStore', ['listarUsuarios', 'gerarDadosAuditoria']),

    async gerarAuditoria() {
      this.showSkeleton = true

      this.form.dataHoraInicio = moment(this.datetimestart).format('YYYY-MM-DD HH:mm:ss')
      this.form.dataHoraFim = moment(this.datetimeend).format('YYYY-MM-DD HH:mm:ss')

      await this.gerarDadosAuditoria(this.form)

      this.eventosAuditoria = this.getDadosAuditoria.map(dado => {
        const data = moment(dado.created_at).format('DD/MM/YYYY HH:mm:ss')

        const user = this.getUsers.find(user => user.id === dado.user_id).name

        return {
          data,
          user,
          ip_address: dado.ip_address,
          evento: this.eventos[`${dado.event}`],
          auditable_type: this.namespaces[`${this.getNamespaceNames(dado.auditable_type)}`],
          auditable_description: dado.auditable_description,
          old_values: dado.old_values,
          new_values: dado.new_values,
        }
      })

      this.showSkeleton = false
      this.showReportData = true
    },

    getNamespaceNames(namespace) {
      return namespace.split('\\')[namespace.split('\\').length - 1]
    },

    cancelEvent(parent) {
      parent.resetPicker()
      this.$emit('input', null)
    },

    toggleUsuarios() {
      this.$nextTick(() => {
        if (this.todosUsuariosSelecionados) {
          this.form.usuarios.splice(0)
        } else {
          this.form.usuarios.splice(0)
          this.form.usuarios = this.usuarios.map(usuario => usuario.value)
        }
      })
    },
  },
}
</script>
